import * as type from '../mutation-type'
import api from '../../api.js'
import * as taskApi from '../../api/task.js'

const state = {
  myTasks: [],
  myTasksTotalCount: 0,
  repayStatistics: {},
  repayStatisticsLogs: [],
  status: undefined
}

const getters = {
  myTaskList: state => state.myTasks,
  myTaskListStatus: state => state.status,
  repayStatistics: state => state.repayStatistics,
  repayStatisticsLogs: state => state.repayStatisticsLogs
}

const actions = {
  async fetchMyTasks ({ commit }, { searchParams, page, size }) {
    const res = await taskApi.fetchMyTasks(page, searchParams, size)
    commit(type.SET_MY_TASKS, res.data)
    commit(type.SET_MY_TASKS_STATUS, searchParams)
  },
  fetchRepayStatistics ({ commit }, { page, size, date }) {
    api.fetchRepayStatistics(page, size, date).then(res => {
      commit(type.SET_REPAY_STATISTICS, res.data.statistics)
      commit(type.SET_REPAY_STATISTICS_LOGS, res.data.logs)
    })
  }
}

const mutations = {
  [type.SET_MY_TASKS] (state, params) {
    state.myTasks = params
  },
  [type.SET_MY_TASKS_STATUS] (state, params) {
    state.status = params
  },
  [type.SET_REPAY_STATISTICS] (state, params) {
    state.repayStatistics = params
  },
  [type.SET_REPAY_STATISTICS_LOGS] (state, params) {
    state.repayStatisticsLogs = params
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
